import axios from 'axios'
import { errorHandler } from '@/shared/errorHandler'

export default {
    loginSebrae(usuario) {
        let promisse = axios.post(
            `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/autenticacao/login/sebrae`,
            usuario
        )
        return promisse
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    loginExterno(usuario) {
        let promisse = axios.post(
            `${process.env.VUE_APP_API_URL}${
                process.env.VUE_APP_API_PATH
            }/autenticacao/login/${usuario.tipoAcesso == 1 ? 'pj' : 'pf'}`,
            usuario
        )
        return promisse
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    solicitarNovaSenha(esqueciMinhaSenhaDto) {
        let promisse = axios.post(
            `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/autenticacao/esqueciminhasenha`,
            esqueciMinhaSenhaDto
        )
        return promisse
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }

    // config () {
    //   let promisse = axios.get(`${process.env.ROOT_URL}${process.env.ROOT_API}/autenticacao/config`)
    //   return promisse.then((response) => {
    //     return response.data
    //   }).catch((error) => {
    //     return errorHandler(error)
    //   })
    // }
}
